/* eslint-disable react/no-multi-comp */
import { buildIntrinsicWidthSources } from '@velasca/utils/build-intrinsic-width-sources'
import { setQueryParams } from '@velasca/utils/set-query-params'
import { Video } from '../Video/Video'
import { BlocksGrid, StyledResponsiveImage, TextBlock } from './Layout1.styles'
import type { GridProps, ItemProps } from './Layout1.types'

export const Grid = ({
  upperTitle,
  title,
  paragraph,
  handle,
  children,
}: GridProps): JSX.Element => {
  return (
    <BlocksGrid id={handle}>
      <TextBlock title={title} upperTitle={upperTitle} paragraph={paragraph} />
      {children}
    </BlocksGrid>
  )
}

export const Item = ({ media }: ItemProps): JSX.Element | null => {
  if (!media) {
    return null
  }

  if (media.type === 'image') {
    return (
      <StyledResponsiveImage
        lqip
        lazyload
        alt={media.alt}
        sources={buildIntrinsicWidthSources({ src: media.src })}
        imgSrc={setQueryParams(media.src, [{ name: 'width', value: '30' }])}
      />
    )
  }

  return <Video poster={media.preview} sources={media.sources} />
}
